var map = {
  "./app-loader-dark.json": [
    "52453",
    "406"
  ],
  "./no-results-dark.json": [
    "95678",
    "435"
  ],
  "./connection-error-dark.json": [
    "66683",
    "992"
  ],
  "./no-data-dark.json": [
    "51054",
    "715"
  ],
  "./not-verified-dark.json": [
    "27702",
    "227"
  ],
  "./permissions-denied.json": [
    "30795",
    "344"
  ],
  "./welcome-dark.json": [
    "96984",
    "633"
  ],
  "./verified.json": [
    "77311",
    "242"
  ],
  "./no-results.json": [
    "87391",
    "484"
  ],
  "./welcome.json": [
    "21789",
    "662"
  ],
  "./connection-error.json": [
    "67572",
    "325"
  ],
  "./not-verified.json": [
    "59751",
    "580"
  ],
  "./app-loader.json": [
    "26498",
    "327"
  ],
  "./permissions-denied-dark.json": [
    "42946",
    "727"
  ],
  "./verified-dark.json": [
    "11550",
    "955"
  ],
  "./no-data.json": [
    "87791",
    "356"
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(function() {
      var e = new Error("Cannot find module '" + req + "'");
      e.code = 'MODULE_NOT_FOUND';
      throw e;
    });
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1]).then(function() {
    return __webpack_require__.t(id, 3 | 16);
  });
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 81863;
module.exports = __rspack_async_context;
